/**
 * @auth 赖传峰
 * @date 2023/2/27
 */
import UAParser from 'ua-parser-js'
import { useRequestHeaders } from '#imports'

export default () =>
  import.meta.server
    ? UAParser(useRequestHeaders(['user-agent'])['user-agent']).device.type === 'mobile'
    : new UAParser().getDevice().type === 'mobile'
